"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@athena-portal/core");
var services_1 = require("@falcon/services");
var React = require("react");
var reactstrap_1 = require("reactstrap");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../../commonFunctions");
var RadioInput_1 = require("../../../../components/RadioInput");
var components_1 = require("@athena-portal/components");
// @ts-ignore
var browser_image_compression_1 = require("browser-image-compression");
var AnnualHomeValuableItemModal = /** @class */ (function (_super) {
    __extends(AnnualHomeValuableItemModal, _super);
    function AnnualHomeValuableItemModal(props) {
        var _this = _super.call(this, props) || this;
        _this.numberOfImages = 2;
        _this.minItemValue = 2000;
        _this.maxItemValue = 10000000;
        _this.state = {
            isOpen: true,
            item: props.item
        };
        _this.handleCategoryChange = _this.handleCategoryChange.bind(_this);
        _this.handleDescriptionChange = _this.handleDescriptionChange.bind(_this);
        _this.handleValueChange = _this.handleValueChange.bind(_this);
        _this.handleLocationChange = _this.handleLocationChange.bind(_this);
        _this.validateValue = _this.validateValue.bind(_this);
        _this.fetchLookupValues = _this.fetchLookupValues.bind(_this);
        _this.finishAddingItem = _this.finishAddingItem.bind(_this);
        _this.removeUnsavedAndClose = _this.removeUnsavedAndClose.bind(_this);
        _this.resetRemoveImagesFlagAndToggleClose = _this.resetRemoveImagesFlagAndToggleClose.bind(_this);
        return _this;
    }
    AnnualHomeValuableItemModal.prototype.componentDidMount = function () {
        this.fetchLookupValues();
    };
    AnnualHomeValuableItemModal.prototype.render = function () {
        var isMta = this.props.interaction.status === services_1.INTERACTION_STATUS_PENDING_MTA;
        return (React.createElement(reactstrap_1.Modal, { className: "cover-amount-modal", isOpen: this.state.isOpen, toggle: isMta ? this.removeUnsavedAndClose : this.props.closeModal },
            React.createElement(reactstrap_1.ModalHeader, { toggle: isMta ? this.removeUnsavedAndClose : this.props.closeModal, close: React.createElement("button", { className: "btn-close", onClick: isMta ? this.removeUnsavedAndClose : this.props.closeModal }) },
                React.createElement("div", { className: "mb-4 text-blue-2 font-weight-medium" }, this.props.title)),
            React.createElement(reactstrap_1.ModalBody, { className: "py-0 fs-16 font-weight-extra-light", cssModule: { 'modal-body': 'modal-body-no-height-limit' } },
                React.createElement("p", null, "Add items to be covered in and out from your home."),
                this.renderCategorySelect(),
                this.renderDescriptionInput(),
                this.renderValueInput(),
                this.renderCoverLocationRadio(),
                isMta && this.renderImageUpload(),
                this.renderHeadUpMessage(),
                this.renderFooter())));
    };
    AnnualHomeValuableItemModal.prototype.renderCategorySelect = function () {
        var _a;
        return (React.createElement("div", { className: "form-group" },
            React.createElement("label", { htmlFor: "item-categories" }, "What kind of item is it?"),
            React.createElement("div", { className: "input-group w-md-75" },
                React.createElement("select", { id: "item-categories", className: "form-control ".concat((0, commonFunctions_1.getValidationStyle)(this.state.isCategoryValid)), onChange: this.handleCategoryChange, value: this.state.item.valuableItemType },
                    React.createElement("option", { value: "" }, "Please select the closest category"), (_a = this.state.lookupValues) === null || _a === void 0 ? void 0 :
                    _a.sort(function (a, b) { return a.value.localeCompare(b.value); }).map(function (key, index) {
                        return React.createElement("option", { key: index, value: key.id }, key.value);
                    }))),
            React.createElement("div", { className: "text-danger fs-14 font-weight-medium mt-2 mt-md-0" }, this.state.isCategoryValid === false && "Please select the type of item")));
    };
    AnnualHomeValuableItemModal.prototype.renderDescriptionInput = function () {
        return (React.createElement("div", { className: "form-group" },
            React.createElement("label", { htmlFor: "description" }, "Describe your item"),
            React.createElement("div", { className: "input-group w-100" },
                React.createElement("input", { type: "text", id: "description", className: "form-control ".concat((0, commonFunctions_1.getValidationStyle)(this.state.isDescriptionValid)), value: this.state.item.description || "", maxLength: 100, onChange: this.handleDescriptionChange })),
            React.createElement("div", { className: "text-danger fs-14 font-weight-medium mt-2 mt-md-0" }, this.state.isDescriptionValid === false && "Please describe your item")));
    };
    ;
    AnnualHomeValuableItemModal.prototype.renderValueInput = function () {
        return (React.createElement("div", { className: "form-group" },
            React.createElement("label", { htmlFor: "value" },
                "How much would it cost to replace this item as new?",
                React.createElement("span", { className: "font-weight-extra-light" }, "(This is the maximum we can pay for this item if you make a claim)")),
            React.createElement("div", { id: "itemCost", className: "input-group d-flex align-items-center" },
                React.createElement("span", { className: "fs-22 font-weight-bold" }, "\u00A3"),
                React.createElement("input", { type: "text", id: "value", className: "form-control w-25 mx-2 ".concat((0, commonFunctions_1.getValidationStyle)(this.state.isValueValid)), value: this.state.item.value || "", onChange: this.handleValueChange }),
                React.createElement("span", null,
                    " (minimum \u00A3",
                    this.minItemValue,
                    ")")),
            React.createElement("div", { className: "text-danger fs-14 font-weight-medium margin-top-16 mt-md-0" },
                this.state.isValueValid === false && !this.state.item.value && "Please enter a value for your item.",
                this.state.isValueValid === false && this.state.item.value && this.state.item.value < this.minItemValue && "Please enter a value more than \u00A3".concat(this.minItemValue, "."),
                this.state.isValueValid === false && this.state.item.value && this.state.item.value > this.maxItemValue && "Sorry, we can’t insure you because of your specified items.")));
    };
    ;
    AnnualHomeValuableItemModal.prototype.renderCoverLocationRadio = function () {
        return (React.createElement(RadioInput_1.RadioInput, { label: "Do you want to cover this item outside your home?", id: "coverOutsideHome", valueTrue: services_1.ValuableItemCoverLocation.ANYWHERE, valueFalse: services_1.ValuableItemCoverLocation.HOME, onChange: this.handleLocationChange, selectedValue: this.state.item.coverLocation, showValidationMessage: this.state.isLocationValid === false }));
    };
    AnnualHomeValuableItemModal.prototype.renderImageUpload = function () {
        return (React.createElement(services_1.MultiImageUploadPanel, { reference: this.state.item.valuableItemId, numberOfImages: this.numberOfImages, compressImage: this.compressImage, footerBlock: this.footerBlock, overlay: this.overlay, toggleParentModalClose: this.resetRemoveImagesFlagAndToggleClose, removeNewAddedImages: this.state.removeUnsavedImages === true }));
    };
    AnnualHomeValuableItemModal.prototype.renderHeadUpMessage = function () {
        var item = this.state.item;
        if (this.shouldInsureAutomatically(item)) {
            return (React.createElement("div", { className: "font-weight-extra-light text-left display-block banner banner-info banner-info-multiple-paragraphs" },
                React.createElement("div", null,
                    "Heads up - ",
                    React.createElement("b", { className: "font-weight-semi-bold" }, " this item is covered as standard inside your home, you don\u2019t need to specify it"))));
        }
        else if (this.props.interaction.process === services_1.INTERACTION_PROCESS_NB) {
            return (React.createElement("div", { className: "font-weight-extra-light text-left display-block banner banner-info" },
                React.createElement("div", null,
                    "Heads up - ",
                    React.createElement("b", { className: "font-weight-semi-bold" }, " you\u2019ll be able to add images & receipts of the item later in your account"))));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    AnnualHomeValuableItemModal.prototype.renderFooter = function () {
        return (React.createElement("div", { className: "d-block alert-close-buttons d-flex flex-column" },
            this.renderConfirmButton(),
            React.createElement("button", { type: "button", className: "btn btn-back width-md-250 display-block mb-1 mt-3", onClick: this.props.interaction.status === services_1.INTERACTION_STATUS_PENDING_MTA ? this.removeUnsavedAndClose : this.props.closeModal }, "Cancel")));
    };
    AnnualHomeValuableItemModal.prototype.renderConfirmButton = function () {
        var style = "btn btn-primary btn-add width-md-250 display-block mb-1";
        if (this.shouldInsureAutomatically(this.state.item)) {
            return (React.createElement("button", { type: "button", className: style, onClick: this.props.closeModal }, "Okay, I understand"));
        }
        else {
            return (React.createElement("button", { type: "button", className: style, onClick: this.finishAddingItem }, this.props.title));
        }
    };
    AnnualHomeValuableItemModal.prototype.compressImage = function (imageFile) {
        return (0, browser_image_compression_1.default)(imageFile, {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920,
            useWebWorker: false
        });
    };
    AnnualHomeValuableItemModal.prototype.overlay = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(components_1.Overlay, { show: true }));
    };
    AnnualHomeValuableItemModal.prototype.footerBlock = function () {
        return React.createElement(React.Fragment, null,
            React.createElement("label", null,
                React.createElement("b", null,
                    "Upload up to ",
                    this.numberOfImages,
                    " photos / receipts of your item")));
    };
    AnnualHomeValuableItemModal.prototype.removeUnsavedAndClose = function () {
        this.setState({
            removeUnsavedImages: true
        });
    };
    AnnualHomeValuableItemModal.prototype.resetRemoveImagesFlagAndToggleClose = function () {
        this.setState({
            removeUnsavedImages: false
        });
        this.props.closeModal();
    };
    AnnualHomeValuableItemModal.prototype.handleCategoryChange = function (event) {
        var item = this.state.item;
        item.valuableItemType = event.target.value;
        var isCategoryValid = Boolean(item.valuableItemType);
        this.setState({
            isCategoryValid: isCategoryValid
        });
    };
    ;
    AnnualHomeValuableItemModal.prototype.handleDescriptionChange = function (event) {
        var item = this.state.item;
        item.description = event.target.value;
        var isDescriptionValid = Boolean(item.description);
        this.setState({
            isDescriptionValid: isDescriptionValid
        });
    };
    ;
    AnnualHomeValuableItemModal.prototype.handleValueChange = function (event) {
        var _this = this;
        if (event.target.value.match("^[0-9]*$")) {
            var item = this.state.item;
            item.value = event.target.value;
            this.setState({
                item: item
            }, function () {
                _this.validateValue(true);
            });
        }
    };
    AnnualHomeValuableItemModal.prototype.handleLocationChange = function (event) {
        var item = this.state.item;
        item.coverLocation = event.target.value;
        var isLocationValid = Boolean(item.coverLocation);
        this.setState({
            isLocationValid: isLocationValid
        });
    };
    ;
    AnnualHomeValuableItemModal.prototype.validateValue = function (updateFieldValidation) {
        var isValueValid = Boolean(this.state.item.value && this.state.item.value >= this.minItemValue && this.state.item.value <= this.maxItemValue);
        updateFieldValidation && this.setState({
            isValueValid: isValueValid
        });
        return isValueValid;
    };
    AnnualHomeValuableItemModal.prototype.finishAddingItem = function () {
        var item = this.state.item;
        var isCategoryValid = Boolean(item.valuableItemType);
        var isDescriptionValid = Boolean(item.description);
        var isLocationValid = Boolean(item.coverLocation);
        var isValueValid = this.validateValue(false);
        if (isCategoryValid && isDescriptionValid && isValueValid && isLocationValid) {
            item.flowValuable = true;
            item.added = true;
            this.setState({
                item: item
            });
            this.props.onConfirm(item);
        }
        else {
            this.setState({
                isCategoryValid: isCategoryValid,
                isDescriptionValid: isDescriptionValid,
                isValueValid: isValueValid,
                isLocationValid: isLocationValid
            });
        }
    };
    AnnualHomeValuableItemModal.prototype.shouldInsureAutomatically = function (item) {
        var type = item.valuableItemType;
        var isLocationHome = item.coverLocation === services_1.ValuableItemCoverLocation.HOME;
        var insuredItemArray = [
            services_1.AnnualHomeAutomaticInsuredItemTypes.COMPUTER,
            services_1.AnnualHomeAutomaticInsuredItemTypes.HEARING,
            services_1.AnnualHomeAutomaticInsuredItemTypes.MUSIC,
            services_1.AnnualHomeAutomaticInsuredItemTypes.PHOTOGRAPHIC_EQUIPMENT,
            services_1.AnnualHomeAutomaticInsuredItemTypes.SPORT,
            services_1.AnnualHomeAutomaticInsuredItemTypes.GUN,
            services_1.AnnualHomeAutomaticInsuredItemTypes.CLOTHING,
            services_1.AnnualHomeAutomaticInsuredItemTypes.WHEELCHAIR,
            services_1.AnnualHomeAutomaticInsuredItemTypes.GADGET,
            services_1.AnnualHomeAutomaticInsuredItemTypes.MOBILE,
        ];
        return isLocationHome && insuredItemArray.includes(type);
    };
    ;
    AnnualHomeValuableItemModal.prototype.fetchLookupValues = function () {
        var _this = this;
        var _a;
        var languageCode = "en-UK";
        var lookupName = "annualHomeValuableItemTypes";
        var currentItemType = ((_a = this.state.item) === null || _a === void 0 ? void 0 : _a.valuableItemType) != null ? this.state.item.valuableItemType : undefined;
        this.lookupService.fetchLookupValues(lookupName, languageCode, currentItemType).subscribe(function (lookupValues) {
            _this.setState({
                lookupValues: lookupValues
            });
        });
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], AnnualHomeValuableItemModal.prototype, "lookupService", void 0);
    return AnnualHomeValuableItemModal;
}(React.Component));
exports.default = AnnualHomeValuableItemModal;
//# sourceMappingURL=AnnualHomeValuableItemModal.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/valuableItemWidget/AnnualHomeValuableItemModal.js
// module id = 3692
// module chunks = 0